import * as animationDataSpacebar from '@/assets/svgs/Spacebar.json'

import * as animationDataSpacebarGeneric from '@/assets/svgs/SpacebarGeneric.json'
import * as animationDataMobileIcon from '@/assets/svgs/MobileIcon.json'

import GetReady from '@/assets/svgs/GetReady'
import Level1Title from '@/assets/svgs/Level1Title'
import Level2Title from '@/assets/svgs/Level2Title'
import Level3Title from '@/assets/svgs/Level3Title'
import LevelComplete from '@/assets/svgs/LevelComplete'
import FinalScore from '@/assets/svgs/FinalScore'
import Seconds from '@/assets/svgs/Seconds'
import SpacebarBegin from '@/assets/svgs/SpacebarBegin'
import SpacebarContinue from '@/assets/svgs/SpacebarContinue'
import SpacebarNext from '@/assets/svgs/SpacebarNext'
import SpacebarResult from '@/assets/svgs/SpacebarResult'


const SVGS = {
    en: {
        Level1Title: JSON.parse(Level1Title.en),
        Level2Title: JSON.parse(Level2Title.en),
        Level3Title: JSON.parse(Level3Title.en),
        GetReady: JSON.parse(GetReady.en),
        Seconds: JSON.parse(Seconds.en),
        LevelComplete: JSON.parse(LevelComplete.en),
        FinalScore: JSON.parse(FinalScore.en),
        Spacebar: animationDataSpacebar,

        SpacebarButton: {
            begin: JSON.parse(SpacebarBegin.en),
            continue: JSON.parse(SpacebarContinue.en),
            next: JSON.parse(SpacebarNext.en),
            result: JSON.parse(SpacebarResult.en),

        },
        Phone: animationDataMobileIcon
    },
    fr: {
        Level1Title: JSON.parse(Level1Title.fr),
        Level2Title: JSON.parse(Level2Title.fr),
        Level3Title: JSON.parse(Level3Title.fr),
        GetReady: JSON.parse(GetReady.fr),
        Seconds: JSON.parse(Seconds.fr),
        LevelComplete: JSON.parse(LevelComplete.fr),
        FinalScore: JSON.parse(FinalScore.fr),
        Spacebar: animationDataSpacebarGeneric,
        SpacebarButton: {
            begin: JSON.parse(SpacebarBegin.fr),
            continue: JSON.parse(SpacebarContinue.fr),
            next: JSON.parse(SpacebarNext.fr),
            result: JSON.parse(SpacebarResult.fr),


        },
        Phone: animationDataMobileIcon
    },
    tc: {
        Level1Title: JSON.parse(Level1Title.tc),
        Level2Title: JSON.parse(Level2Title.tc),
        Level3Title: JSON.parse(Level3Title.tc),
        GetReady: JSON.parse(GetReady.tc),
        Seconds: JSON.parse(Seconds.tc),
        LevelComplete: JSON.parse(LevelComplete.tc),
        FinalScore: JSON.parse(FinalScore.tc),
        Spacebar: animationDataSpacebarGeneric,
        Phone: animationDataMobileIcon
    },
    sc: {
        Level1Title: JSON.parse(Level1Title.sc),
        Level2Title: JSON.parse(Level2Title.sc),
        Level3Title: JSON.parse(Level3Title.sc),
        GetReady: JSON.parse(GetReady.sc),
        Seconds: JSON.parse(Seconds.sc),
        LevelComplete: JSON.parse(LevelComplete.sc),
        FinalScore: JSON.parse(FinalScore.sc),
        Spacebar: animationDataSpacebarGeneric,
        Phone: animationDataMobileIcon
    }
}

export { SVGS }
